import { FormProvider, useForm } from 'react-hook-form';
import { DisableUserReq, UserRes, UserRole } from '../../services/api.types';
import { ConfirmationModal } from '../ConfirmationModal';
import { Checkbox } from '../Checkbox';
import { usersService } from '../../services/users.service';
import { useToast } from '../../hooks';
import { useState } from 'react';

export type DisableModalProps = {
  open: boolean;
  onCancel: () => void;
  onDisable: () => void;
  showDeleteCheckbox?: boolean;
  user: UserRes;
};

export const DisableModal = ({
  open,
  onCancel,
  onDisable,
  showDeleteCheckbox,
  user,
}: DisableModalProps) => {
  const toast = useToast();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const disableForm = useForm<DisableUserReq>({
    mode: 'all',
    defaultValues: { deleteEvents: false },
  });

  const handleDeactivate = async () => {
    const toDelete = showDeleteCheckbox
      ? disableForm.getValues().deleteEvents
      : false;
    const deleteEventsWhenDisable: DisableUserReq = {
      deleteEvents: toDelete,
    };

    setIsLoading(true);
    await usersService
      .disableUser(user.id, deleteEventsWhenDisable)
      .then(() => {
        onDisable();
        toast.success('Usuário alterado com sucesso!');
      })
      .finally(() => {
        setIsLoading(false);
        onCancel?.();
      });
  };

  return (
    <ConfirmationModal
      open={open}
      onAccept={handleDeactivate}
      onDecline={onCancel}
      isLoading={isLoading}
    >
      <div className="flex flex-col">
        <h3>Você tem certeza que quer desativar esse usuário?</h3>

        {showDeleteCheckbox ? (
          <FormProvider {...disableForm}>
            <div>
              <Checkbox
                name="deleteEvents"
                label={`Desmarcar eventos futuros associados a esse(a) ${
                  user.role === UserRole.TEACHER ? 'professor(a)' : 'aluno(a)'
                }`}
              />
            </div>
          </FormProvider>
        ) : undefined}
      </div>
    </ConfirmationModal>
  );
};
